import { useEffect } from "react";
import { Checkbox, Form, Upload, Button } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { fileUploadProps, normFile } from "@/lib/uploadFunction";
import { getLangList } from "@/lib/i18n";
import { modalFromLayout } from "@/lib/antdElementFunction";
import { DocumentType } from './types';

type Props = {
  form: any,
  info: DocumentType,
  handleType: string,
}

function DocumentModal(props: Props) {
  const { form, info, handleType } = props;
  const scheduleT: any = getLangList("schedule");
  const homeT: any = getLangList("home");
  const options = [
    { label: scheduleT.TEACHER, value: 2 },
    { label: scheduleT.STUDENT, value: 1 },
  ];

  useEffect(() => {
    const { personType } = info ?? {};

    handleType === 'update' && form.setFieldsValue({ personType: personType === 0 ? [1, 2] : [personType] });
  }, [form, info, handleType]);

  return (
    <Form
      className="admin-form"
      style={{ marginTop: 20 }}
      {...modalFromLayout}
      form={form}
    >
      <Form.Item
        label={scheduleT.ANNOUNCEMENT_TARGET}
        name="personType"
        rules={[{ required: true }]}
      >
        <Checkbox.Group options={options} />
      </Form.Item>

      {handleType === 'create' && (
        <Form.Item
          label={homeT.DOCUMENT}
          name="file"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload {...fileUploadProps}>
            <Button icon={<UploadOutlined />}>Click to Upload</Button>
          </Upload>
        </Form.Item>
      )}
    </Form >
  );
}

export default DocumentModal;